export default __webpack_public_path__ + "static/media/manulife-logo.faf7bc87.svg";